import script from "./CurrentDataPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentDataPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentDataPanel.vue?vue&type=style&index=0&id=892aba70&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-892aba70"]])

export default __exports__